<template>
  <el-form
    style="margin-top: 16px"
    :model="relation"
    ref="form"
    label-width="140px"
  >
    <template v-for="key in keys(field)">
      <el-form-item
        :key="key"
        v-if="enabled(properties, entity, field, key)"
        :label="label(field, key)"
        :rules="rules(key)"
        :prop="key"
      >
        <el-input
          v-if="htmlField(field, key) === 'text'"
          v-model="relation[key]"
        ></el-input>

        <el-select
          v-if="
            htmlField(field, key) === 'select' &&
              choices &&
              choices.length
          "
          v-model="relation[key]"
          placeholder="Please select one option"
        >
          <el-option
            v-if="!required(field, key)"
            label="Please select one option"
            value
          />
          <el-option
            v-for="choice in choices(key)"
            :key="choice.value"
            :label="choice.label"
            :value="choice.value"
          ></el-option>
        </el-select>

        <el-input-number
          v-if="htmlField(field, key) === 'number'"
          v-model="relation[key]"
        ></el-input-number>

        <el-color-picker
          v-if="htmlField(field, key) === 'color'"
          v-model="relation[key]"
        ></el-color-picker>

        <div
          class="leading-7 text-xs font-medium text-gray-500"
          v-if="help(field, key)"
        >
          {{ help(field, key) }}
        </div>
      </el-form-item>
    </template>
  </el-form>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'app-entity-form-relation',

  mounted() {
    if (this.keys && this.keys(this.field)) {
      this.keys(this.field).forEach((key) => {
        const referenceKey = `tooltip${key}`;
        if (
          this.$refs[referenceKey] &&
          this.$refs[referenceKey].referenceElm
        ) {
          this.$refs[
            referenceKey
          ].referenceElm.setAttribute('tabindex', -1);
        }
      });
    }
    this.$store.commit(
      'builder/fieldCurrent/relationForm',
      this.$refs.form,
    );
  },

  computed: {
    ...mapGetters({
      properties: 'builder/propertyCurrent/current',
      entity: 'builder/entityCurrent/current',
      entities: 'builder/entityCurrent/list',
      field: 'builder/fieldCurrent/current',
      keys: 'builder/fieldRelation/keys',
      enabled: 'builder/fieldRelation/enabled',
      required: 'builder/fieldRelation/required',
      label: 'builder/fieldRelation/label',
      htmlField: 'builder/fieldRelation/htmlField',
      help: 'builder/fieldRelation/help',
    }),

    choices() {
      return (key) => {
        return this.$store.getters[
          'builder/fieldRelation/choices'
        ](this.entities, this.entity, this.field, key);
      };
    },

    relation() {
      return this.field.relation;
    },

    rules() {
      return (key) => {
        if (!this.required(this.field, key)) {
          return null;
        }

        const rules = {
          required: true,
          message: `${this.label(
            this.field,
            key,
          )} is required`,
          trigger: 'blur',
        };

        if (this.htmlField(this.field, key) === 'number') {
          rules.type = 'number';
        }

        return rules;
      };
    },
  },
};
</script>

<style></style>
